export interface EventManagerValue
{
    token: number,
    callback: (...args) => void
}

export class EventManager<TKey>
{
    private _eventList: Map<TKey, EventManagerValue[]> = new Map<TKey, EventManagerValue[]>();
    private _token: number = 0;

    public on(event: TKey, callback: (...args) => void): number
    {
        this.has(event) || this._eventList.set(event, []);
        this._token += 1;
        
        this._eventList.get(event).push({
            token: this._token,
            callback: callback
        });

        return this._token;
    }

    public off(event: TKey, token: number = null)
    {
        if (token == null)
        {
            return this._eventList.delete(event);
        }
        else
        {
            const events = this._eventList.get(event).where(e => e.token !== token);
            this._eventList.set(event, events);
        }
    }

    public emit(event: TKey, ...args): any
    {
        if (!this.has(event))
        {
            console.warn(`"${event}" Event is not registered. Did you forgot to bind the event?`);
            return false;
        }
        else
        {
            var returnValues = [];
            this._eventList.get(event).forEach(listener => returnValues.push({ [listener.token]: (listener.callback != null) ? listener.callback.call(this, ...args) : undefined }));
            return returnValues;
        }
    }

    public has(event: TKey): boolean
    {
        return this._eventList.has(event);
    }

    public getToken(event: TKey): number
    {
        if (this.has(event))
        {
            return this._eventList.get(event).first().token;
        }
    }
}